const slugify = require("slugify");

var createSlug = function(title, locale){
    return "/" + locale + "/" + slugify(title, { lower: true });
}

module.exports.createSlug = createSlug
